/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();


window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),

    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),

     // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',
     // Search Page       
    $searchInput: $('.search-bar__input'),
    $searchSubmit: $('.search-bar__submit')
    
  }
};

theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav();  
 theme.cartPage();
  theme.drawersInit();
};


theme.cartPage = function () {
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');   
  });
};
theme.drawersInit = function () {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');  
  $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');  
  theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {'onDrawerOpen': theme.searchFocus});
};

theme.searchFocus = function () {
  theme.cache.$searchInput.focus();
  // set selection range hack for iOS
  theme.cache.$searchInput[0].setSelectionRange(0, theme.cache.$searchInput[0].value.length);
};

theme.searchSubmit = function () {
  theme.cache.$searchSubmit.on('click', function(evt) {
    if (theme.cache.$searchInput.val().length == 0) {
      evt.preventDefault();
      theme.cache.$searchInput.focus();
    }
  });
};


theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);

    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.$nodes.parent.on('keyup.drawer', $.proxy(function (evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      }
    }, this));

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.$nodes.page.off('.drawer');
    this.$nodes.parent.off('.drawer');
  };

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function (options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  };

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  };

  return Drawer;
})();
// Initialize shop's JS on docready
$(theme.init);




$(".searchbox-drawer").click(function(){
  $(".search-icon324 span.fa.fa-search").css("top", "0");
});

// $(document).ready(function(){
//     var count = $(".mini-products-list li").length;
//     if(count == 0){
//     	 $("#ToggleDown > .cartCoun").css("display", "none");
//     }else{
//        $("#ToggleDown > .cartCoun").css("display", "inline");
//     }
   
// });

window.setInterval(function(){
    var count = $(".mini-products-list li").length;
    if(count == 0){
    	 $("#ToggleDown > .cartCoun").css("display", "none");
    }else{
       $("#ToggleDown > .cartCoun").css("display", "inline");
    }
}, 1000);

window.minivar=0;


// $("#AddToCart").click(function(){
//   	window.location.href='https://lifetimejewelry.com/cart';
// });
// $("#ToggleDown").mouseover(function(e){
//   	$("#closeCart").css("display", "block");
  
//       $(".has-items").css("display", "flex");
  
//   	$("html").css("overflow-x", "hidden");
//   	$("#slidedown-cart").css('right','-150vw');
  	//$("#slidedown-cart").css("display", "block");
//   	$("#slidedown-cart").animate({width: "390px"});
  	//$("#slidedown-cart").css("width", "80vw");
  	//$("#slidedown-cart").slideRight("slow");
  	//$("#slidedown-cart").show('slide', {direction: 'left'}, 1000);
  	//$("#slidedown-cart").show();
//   	$("#slidedown-cart").show();
//     $('#slidedown-cart').animate({
//       right: '0px'
//     });
//     console.log('mouseover');
//   	window.minivar=1;
//   	setTimeout(function(){window.minivar=0;},5000);
  
// });
// $("#slidedown-cart").mouseleave(function(e){
//   	$("#closeCart").css("display", "none");
//   	$(".has-items").css("display", "none");
//   	$("html").css("overflow", "auto");
  	//$("#slidedown-cart").css("width", "0px");
  	//$("#slidedown-cart").slideUp();
  	//$("#slidedown-cart").hide('slide', {direction: 'right'}, 1000);
  	//$("#slidedown-cart").hide('slide', {direction: 'right'}, 1000);
//   	$('#slidedown-cart').animate({
//           right: '-150vw'
//       });
//   	console.log('mouseleave');
// });


$("#ToggleDown").click(function(){
  	$("#closeCart").css("display", "block");
  	$(".has-items").css("display", "block");
  	$("html").css("overflow", "hidden");
  	$("#slidedown-cart").css("display", "block");
  	$("#slidedown-cart").animate({width: "390px"});
});

$("#closeCart").click(function(){
  	$("#closeCart").css("display", "none");
  	$(".has-items").css("display", "none");
  	$("html").css("overflow", "auto");
  	$("#slidedown-cart").animate({width: "0px"});
  	$("#slidedown-cart").slideUp();
});
$("#AddToCart").click(function(){
  	$("#slidedown-cart").css("display", "none");
    $("#AddToCart .addToMyBagText").html("Adding to cart...");
  	$("#AddToCart").css("background-color", "#808080");
      setTimeout( function(){ 
      $("#AddToCart .addToMyBagText").html("ADD MORE");
      $("#AddToCart").css("background-color", "#21155d");
    },2000 );
});
// $("#AddToCart").click(function(){
//   	$("#slidedown-cart").css("display", "block");
//   	$("#closeCart").css("display", "block");
//   	$(".has-items").css("display", "block");
//   	$("html").css("overflow", "hidden");
//   	$("#slidedown-cart").animate({width: "390px"});
// });

// $(".add-to-cart-btn").click(function(){
//   	$("#slidedown-cart").css("display", "block");
//   	$("#closeCart").css("display", "block");
//   	$("#slidedown-cart").animate({width: "390px"});
// });

// $("#ToggleDown").click(function(){
//   	$(".overlay_form_cart").css({"position":"absolute", "z-index": "99", "height":"100vh","width":"100%", "background":"#000000b3"});
// });
// $("#AddToCart").click(function(){
//   	$(".overlay_form_cart").css({"position":"absolute", "z-index": "99", "height":"100vh","width":"100%", "background":"#000000b3"});
// });
// $("#closeCart").click(function(){
//   	$(".overlay_form_cart").css("height", "0");
// });
// $(".overlay_form_cart").click(function(){
//   	$(".overlay_form_cart").css("height", "0");
// });

// =============================

// $(function() {
//   window.a=0;
// $('#create_customer').submit(function(event) {
//   if(window.a==0){
//   event.preventDefault();
//     var n = Math.floor(100000 + Math.random() * 900000);
//   $.get("http://bulletinglobal.com/demo/send_email.php?e="+$('#Email').val()+'&num='+n, function(data, status){
//     window.a=1;
//     $('#create_customer').submit();
//   });
//   }

 
// }); 
// });



// $(function() {
// $('#create_customer').submit(function(event) {
//   event.preventDefault();
  
//     if($('#web_order_id').val().includes('_')){
//       alert('Please enter 4 digit Website Order #');
//       $('#web_order_id').focus();
//       return false;
//     }else{
//       $('#create_customer').submit();
//     }
    
// }); 
// });

$(function(){
  $('#web_order_id').on('keyup', function(){
    if($(this).val().includes("_")){
      $('#form_submit_btn').attr('disabled','disabled');
      $('.err_w').show();
    }else{
      $('#form_submit_btn').removeAttr('disabled');
      $('.err_w').hide();
    }
  });
  
  $('#amazon_order_id').on('keyup', function(){
    if($(this).val().includes("_")){
      $('#form_submit_btn').attr('disabled','disabled');
      $('.err_o').show();
    }else{
      $('#form_submit_btn').removeAttr('disabled');
      $('.err_o').hide();
    }
  });
  
  setInterval(function(){
  $('#slidedown-cart .btn').removeAttr("disabled");
  },1000);
  
});



$("#MobileNav li:nth-child(3) .mobile-nav__sublist li:nth-child(5)").click(function () {
  	$("#MobileNav li:nth-child(3) .mobile-nav__sublist li:nth-child(5)").css("display", "none");
    $("#MobileNav li:nth-child(3) .mobile-nav__sublist li:nth-child(6)").css("display", "block");
  	$("#MobileNav li:nth-child(3) .mobile-nav__sublist li:nth-child(7)").css("display", "block");
  	$("#MobileNav li:nth-child(3) .mobile-nav__sublist li:nth-child(8)").css("display", "block");
});

var url= window.location.href; 
    var value = url.split("/")[3]
    
function myFunction(x) {
  if (x.matches) { 
    $(".cart_client_review").parents('div').css({"display":"grid", "position":"relative"});
  } 
}

var x = window.matchMedia("(max-width: 800px)")
myFunction(x) 
x.addListener(myFunction) 



// var url= window.location.href; 
//     var valuee = url.split("/")[4]
    
//     if (valuee == "earrings") {
//       $(".selector-wrapper-secton div.header").css("opacity", "1");
//       $(".selector-wrapper-secton span.size-title").css("top", "0");

// 	}

$(document).ready( function() {
  $('a[href^="/account/logout"]').on("click", function() {
    $.ajax( $(this).attr('href') )
      .done(function() {
       // Here you will change the url to whatever page you want to redirect to
       window.location.href = "/account/login";
      });
    return false;
  });
});


$(document).ready(function() {
$("#productSelect-option-0").prop("disabled", true);
});

// $(document).ready(function() {
// 	$("input[name='option-0']:checked").prev().css({"opacity": "1", "visibility": "visible"});
// 	$('input[type=radio][name="option-0"]').change(function() {
		
//       	$("input[name='option-0']:checked").attr("id","SomeID");
      
// 	});
// });


$(document).ready(function(){

  setTimeout(function(){
    if(getCookie('bottom_cookie')!=1){
      jQuery('.bottom_cookie').show(); 
    }
  },2000);

  jQuery('.bottom_cookie_btn').on('click',function(){
    setCookie('bottom_cookie',1,1);
    jQuery('.bottom_cookie').hide();
  });
  
  setTimeout(function(){
    $(".swatch-section .swatch-element input[name='option-0']").each(function() {
      var radioValue = $(this).val();
      var word = radioValue.split("- ").pop();
        console.log(word);
      if(word){
        if(word=="Garnet")
          jQuery(this).next().css('background-color','#b91e2d');
        if(word=="Amethyst")
          jQuery(this).next().css('background-color','#835a9f');
        if(word=="Aquamarine")
          jQuery(this).next().css('background-color','#94d6e4');
        if(word=="Diamond")
          jQuery(this).next().css('background-color','#ffffff');
        if(word=="Emerald")
          jQuery(this).next().css('background-color','#008140');
        if(word=="Alexandrite")
          jQuery(this).next().css('background-color','#cfc5e0');
        if(word=="Ruby")
          jQuery(this).next().css('background-color','#991f24');
        if(word=="Peridot")
          jQuery(this).next().css('background-color','#aaca6d');
        if(word=="Sapphire")
          jQuery(this).next().css('background-color','#1d337a');
        if(word=="Pink Ice")
          jQuery(this).next().css('background-color','#f8c8d1');
        if(word=="Citrine")
          jQuery(this).next().css('background-color','#e8c214');
        if(word=="Blue Zircon")
          jQuery(this).next().css('background-color','#55b0c8');
        if(word=="Rose Zircon")
          jQuery(this).next().css('background-color','#c671cb');
        if(word=="Gold Topaz")
          jQuery(this).next().css('background-color','#e8c214');
        if(word=="Pink Tourmaline (Pink Ice)")
          jQuery(this).next().css('background-color','#f8c8d1');
        if(word=="Pink Tourmaline")
          jQuery(this).next().css('background-color','#f8c8d1');
        if(word=="White Gold")
          jQuery(this).next().css('background-color','#ffffff');
        if(word=="Gunmetal")
          jQuery(this).next().css('background-color','#5A676C');
        if(word=="Stainless Steel")
          jQuery(this).next().css('background-color','#dadada');
        if(word=="Rhodium")
          jQuery(this).next().css('background-color','#ffffff');
        
      }
    });
  },400);
  setTimeout(function(){
    $(".swatch-section .swatch-element input[name='option-0']").each(function() {
      var radioValue = $(this).val();
      var word = radioValue.split("- ").pop();
        console.log(word);
      if(word){
        if(word=="Garnet")
          jQuery(this).next().css('background-color','#b91e2d');
        if(word=="Amethyst")
          jQuery(this).next().css('background-color','#835a9f');
        if(word=="Aquamarine")
          jQuery(this).next().css('background-color','#94d6e4');
        if(word=="Diamond")
          jQuery(this).next().css('background-color','#ffffff');
        if(word=="Emerald")
          jQuery(this).next().css('background-color','#008140');
        if(word=="Alexandrite")
          jQuery(this).next().css('background-color','#cfc5e0');
        if(word=="Ruby")
          jQuery(this).next().css('background-color','#991f24');
        if(word=="Peridot")
          jQuery(this).next().css('background-color','#aaca6d');
        if(word=="Sapphire")
          jQuery(this).next().css('background-color','#1d337a');
        if(word=="Pink Ice")
          jQuery(this).next().css('background-color','#f8c8d1');
        if(word=="Citrine")
          jQuery(this).next().css('background-color','#e8c214');
        if(word=="Blue Zircon")
          jQuery(this).next().css('background-color','#55b0c8');
        if(word=="Rose Zircon")
          jQuery(this).next().css('background-color','#c671cb');
        if(word=="Gold Topaz")
          jQuery(this).next().css('background-color','#e8c214');
        if(word=="Pink Tourmaline (Pink Ice)")
          jQuery(this).next().css('background-color','#f8c8d1');
        if(word=="Pink Tourmaline")
          jQuery(this).next().css('background-color','#f8c8d1');
        if(word=="White Gold")
          jQuery(this).next().css('background-color','#ffffff');
        if(word=="Gunmetal")
          jQuery(this).next().css('background-color','#5A676C');
        if(word=="Stainless Steel")
          jQuery(this).next().css('background-color','#dadada');
        if(word=="Rhodium")
          jQuery(this).next().css('background-color','#ffffff');
      }
    });
  },1400);
});



$(document).ready(function(){

  window.tb = 1;
  setInterval(function(){
    if(window.tb%2==0){
      jQuery('.shipping-bar1').hide();
      jQuery('.shipping-bar2').show();
    }else{
      jQuery('.shipping-bar1').show();
      jQuery('.shipping-bar2').hide();
    }
    window.tb++;
  },3000);

  //$('ul.site-nav>li').eq(2).find('a').attr('target','_blank');
  //$('ul#MobileNav>li').eq(3).find('a').attr('target','_blank');
  //ul#MobileNav
//   if($('#productSelect-option-1').length>0){
//       $('body').addClass('multiple_variants_class');
//   }
  
  if($( "div[data-value*='With Chain' i]").length>0){
    $('body').addClass('multiple_variants_class');
  }
  else if($( "div[data-value*='Without Chain' i]").length>0){
    $('body').addClass('multiple_variants_class');
  }
              
  
  $('#extra-large-square-grid-cross #AddToCartForm #productSelect-option-1').attr('disabled', 'disabled');
  jQuery('#extra-large-filigree-crucifix [data-option-index="1"] .swatch-section .rounded-crucifix').last().addClass('last-product');
//   setTimeout(function(){
  
//   if(window.location.href.indexOf("thank-you") > -1){
//   	  document.cookie = '__kla_id=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
//   }
  
  if(window.location.href.indexOf("copy-of-4mm-figaro-anklet") > -1){
  	window.location.href="/products/deal-of-the-month";
  }
  
  if(window.location.href.indexOf("copy-of-5mm-mariner-link-anklet") > -1){
  window.location.href="/products/deal-of-the-month";
  }
  
  if(window.location.href.indexOf("copy-of-2mm-anklet-rope-chain") > -1){
  window.location.href="/products/deal-of-the-month";
  }

  if(window.location.href.indexOf("lifetime-jewelry-cubic-zirconia-circle-birthstone-stud-earrings-24k-gold-plated") > -1){
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    var word = radioValue.split("- ").pop();
      console.log(word);
    if(word){
      if(word=="Amethyst")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-545px, 0px, 0px)');
      if(word=="Peridot")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1500px, 0px, 0px)');
      if(word=="Sapphire")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-240px, 0px, 0px)');
      if(word=="Garnet")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1338px, 0px, 0px)');
      if(word=="Emerald")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1030px, 0px, 0px)');
      if(word=="Alexandrite")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-715px, 0px, 0px)');
      if(word=="Pink Tourmaline (Pink Ice)")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-915px, 0px, 0px)');
      if(word=="Rose Zircon")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-550px, 0px, 0px)');
      if(word=="Diamond")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1185px, 0px, 0px)');
      if(word=="Blue Zircon")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(60px, 0px, 0px)');
      if(word=="Gold Topaz")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-395px, 0px, 0px)');
      if(word=="Ruby")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1340px, 0px, 0px)');
      if(word=="Aquamarine")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-80px, 0px, 0px)');
    }
  });
  }
  
  if(window.location.href.indexOf("lifetime-jewelry-cubic-zirconia-button-birthstone-stud-earrings-24k-gold-plated") > -1){
    
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    var word = radioValue.split("- ").pop();
      console.log(word);
    if(word){
      if(word=="Garnet")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(250px, 0px, 0px)');
      if(word=="Amethyst")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(145px, 0px, 0px)');
      if(word=="Aquamarine")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-50px, 0px, 0px)');
      if(word=="Diamond")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-250px, 0px, 0px)');
      if(word=="Emerald")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-400px, 0px, 0px)');
      if(word=="Alexandrite")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-555px, 0px, 0px)');
      if(word=="Ruby")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-710px, 0px, 0px)');
      if(word=="Peridot")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-870px, 0px, 0px)');
      if(word=="Sapphire")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1030px, 0px, 0px)');
      if(word=="Pink Ice")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1175px, 0px, 0px)');
      if(word=="Citrine")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1345px, 0px, 0px)');
      if(word=="Blue Zircon")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1480px, 0px, 0px)');
    }
  });
  }
	
  if(window.location.href.indexOf("lifetime-jewelry-cubic-zirconia-heart-birthstone-stud-earrings-24k-gold-plated") > -1){
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    var word = radioValue.split("- ").pop();
      console.log(word);
    if(word){
      if(word=="Garnet")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(250px, 0px, 0px)');
      if(word=="Amethyst")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(145px, 0px, 0px)');
      if(word=="Aquamarine")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-50px, 0px, 0px)');
      if(word=="Diamond")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-250px, 0px, 0px)');
      if(word=="Emerald")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-400px, 0px, 0px)');
      if(word=="Alexandrite")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-555px, 0px, 0px)');
      if(word=="Ruby")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-710px, 0px, 0px)');
      if(word=="Peridot")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-870px, 0px, 0px)');
      if(word=="Sapphire")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1030px, 0px, 0px)');
      if(word=="Pink Ice")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1175px, 0px, 0px)');
      if(word=="Citrine")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1345px, 0px, 0px)');
      if(word=="Blue Zircon")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1480px, 0px, 0px)');
    }
  });
  }



    if(window.location.href.indexOf("lifetime-jewelry-anklets-for-women-men-and-teen-girls-24k-gold-plated-1mm-rope-chain-ankle-bracelet-to-wear-at-beach-or-party-cute-surfer-anklet-9-10-and-11-inches") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("lifetime-jewelry-anklets-for-women-men-and-teen-girls-24k-gold-plated-1mm-rope-chain-ankle-bracelet-to-wear-at-beach-or-party-cute-surfer-anklet-9-10-and-11-inches") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="White Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-820px, 0px, 0px)');
      }
    });
}


if(window.location.href.indexOf("lifetime-jewelry-anklets-for-women-men-and-teen-girls-24k-gold-plated-2mm-rope-chain-ankle-bracelet-to-wear-at-beach-or-party-cute-surfer-anklet-9-10-and-11-inches") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("lifetime-jewelry-anklets-for-women-men-and-teen-girls-24k-gold-plated-2mm-rope-chain-ankle-bracelet-to-wear-at-beach-or-party-cute-surfer-anklet-9-10-and-11-inches") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="White Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-820px, 0px, 0px)');
      }
    });
}


if(window.location.href.indexOf("lifetime-jewelry-anklets-for-women-teen-girls-5mm") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("lifetime-jewelry-anklets-for-women-teen-girls-5mm") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="White Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1150px, 0px, 0px)');
      }
    });
}

if(window.location.href.indexOf("1mm-rope-chain-bracelet-24k-gold-plated-for-women-and-girls") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("1mm-rope-chain-bracelet-24k-gold-plated-for-women-and-girls") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="White Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-940px, 0px, 0px)');
      }
    });
}

if(window.location.href.indexOf("lifetime-jewelry-rope-bracelet-3mm-diamond-cut-24k-gold-with-inlaid-bronze-premium-fashion-jewelry-resists-tarnishing-guaranteed-for-life-7-9-inches") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("lifetime-jewelry-rope-bracelet-3mm-diamond-cut-24k-gold-with-inlaid-bronze-premium-fashion-jewelry-resists-tarnishing-guaranteed-for-life-7-9-inches") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="White Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-820px, 0px, 0px)');
      }
    });
}

if(window.location.href.indexOf("lifetime-jewelry-rope-bracelet-7mm-diamond-cut-24k-gold-with-inlaid-bronze-premium-fashion-jewelry-resists-tarnishing-guaranteed-for-life-7-9-inches") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("lifetime-jewelry-rope-bracelet-7mm-diamond-cut-24k-gold-with-inlaid-bronze-premium-fashion-jewelry-resists-tarnishing-guaranteed-for-life-7-9-inches") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="White Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1150px, 0px, 0px)');
      }
    });
}

if(window.location.href.indexOf("gold-plated-rope-bracelet-6mm") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("gold-plated-rope-bracelet-6mm") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="White Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-650px, 0px, 0px)');
      }
    });
}

  if(window.location.href.indexOf("gold-plated-rope-chain-bracelet-5mm") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("gold-plated-rope-chain-bracelet-5mm") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="White Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1130px, 0px, 0px)');
      }
    });
}

    if(window.location.href.indexOf("2-5mm-figaro-chain-anklet-gold-plated") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("2-5mm-figaro-chain-anklet-gold-plated") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1150px, 0px, 0px)');
      }
    });
}

  if(window.location.href.indexOf("lifetime-jewelry-ankle-bracelets-for-women-men-and-teen-girls-4mm-gold-mariner-link-chain-anklet-20x-more-real-24k-plating-than-other-foot-jewelry-cute-durable-for-beach-or-wedding-9-10-11") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("lifetime-jewelry-ankle-bracelets-for-women-men-and-teen-girls-4mm-gold-mariner-link-chain-anklet-20x-more-real-24k-plating-than-other-foot-jewelry-cute-durable-for-beach-or-wedding-9-10-11") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-810px, 0px, 0px)');
      }
    });
}

  if(window.location.href.indexOf("lifetime-jewelry-figaro-bracelet-7mm-24k-thick-gold-plated-wrist-chain-for-men-or-women-comes-in-pouch-for-gift-giving-available-from-7-9-inches") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("lifetime-jewelry-figaro-bracelet-7mm-24k-thick-gold-plated-wrist-chain-for-men-or-women-comes-in-pouch-for-gift-giving-available-from-7-9-inches") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-980px, 0px, 0px)');
      }
    });
}


  if((window.location.href.indexOf("2mm-rope-chain-new") > -1)||(window.location.href.indexOf("2mm-rope-chain") > -1)){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("2mm-rope-chain") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1150px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2640px, 0px, 0px)');
        if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3800px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-5110px, 0px, 0px)');
      }else{
       if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1100px, 0px, 0px)');
        if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2400px, 0px, 0px)');   
      }
      
   
    });
}

  if((window.location.href.indexOf("3mm-rope-chain-new") > -1)||(window.location.href.indexOf("lifetime-jewelry-3mm-rope-chain-gold-plated") > -1)){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

      if(window.location.href.indexOf("lifetime-jewelry-3mm-rope-chain-gold-plated") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-980px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2300px, 0px, 0px)');
        if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3630px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-4940px, 0px, 0px)');
      }else{
       if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1100px, 0px, 0px)');
          if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2400px, 0px, 0px)');  
      }
      
    
      
    });
}

    if((window.location.href.indexOf("4mm-rope-chain-new") > -1)||(window.location.href.indexOf("lifetime-jewelry-4mm-rope-chain-24k-gold-with-inlaid-bronze-premium-fashion-jewelry-pendant-necklace-made-to-wear-alone-or-with-charms-guaranteed-for-life-16-to-30-inches") > -1)){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

      if(window.location.href.indexOf("lifetime-jewelry-4mm-rope-chain-24k-gold-with-inlaid-bronze-premium-fashion-jewelry-pendant-necklace-made-to-wear-alone-or-with-charms-guaranteed-for-life-16-to-30-inches") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-820px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2140px, 0px, 0px)');
        if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3460px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-4775px, 0px, 0px)');
      }else{
       if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1300px, 0px, 0px)');
          if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2600px, 0px, 0px)'); 
      }
      
    
      
    });
}


  if((window.location.href.indexOf("5mm-rope-chain-new") > -1)||(window.location.href.indexOf("5mm-gold-plated-rope-chain-pendant-chain") > -1)){
  $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

      if(window.location.href.indexOf("5mm-gold-plated-rope-chain-pendant-chain") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-970px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2300px, 0px, 0px)');
        if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3620px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-4940px, 0px, 0px)');
      }else{
       if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1300px, 0px, 0px)');
          if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2600px, 0px, 0px)'); 
      }
      
    
      
    });
}


  if((window.location.href.indexOf("6mm-rope-chain-new") > -1)||(window.location.href.indexOf("6mm-gold-plated-rope-chain") > -1)){
  $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);

    if(window.location.href.indexOf("6mm-gold-plated-rope-chain") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-810px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2140px, 0px, 0px)');
        if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3460px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-4775px, 0px, 0px)');
      }else{
       if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1300px, 0px, 0px)');
          if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2600px, 0px, 0px)');
      }
    

      
    });
}


    if((window.location.href.indexOf("7mm-rope-chain-new") > -1)||(window.location.href.indexOf("lifetime-jewelry-rope-chain-7mm-24k-diamond-cut-fashion-jewelry-necklaces-in-yellow-or-white-gold-over-semi-precious-metals-hip-hop-or-classic-16-36-inches") > -1)){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);
      
      if(window.location.href.indexOf("lifetime-jewelry-rope-chain-7mm-24k-diamond-cut-fashion-jewelry-necklaces-in-yellow-or-white-gold-over-semi-precious-metals-hip-hop-or-classic-16-36-inches") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-970px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2300px, 0px, 0px)');
        if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3620px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-4940px, 0px, 0px)');
      }else{
       if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1300px, 0px, 0px)');
          if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2600px, 0px, 0px)');
      }
      
    });
}

if(window.location.href.indexOf("8mm-rope-chain") > -1){
  $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);
      if(radioValue=="Gold")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
    if(radioValue=="Black")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1100px, 0px, 0px)');
    if(radioValue=="Gunmetal")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2300px, 0px, 0px)');
      if(radioValue=="Stainless Steel")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3450px, 0px, 0px)');
    });
}

if(window.location.href.indexOf("9mm-rope-chain") > -1){
  $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);
    if(radioValue=="Gold")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
    if(radioValue=="Black")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1000px, 0px, 0px)');
    if(radioValue=="Gunmetal")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2300px, 0px, 0px)');
      if(radioValue=="Stainless Steel")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3450px, 0px, 0px)');
    });
}

if(window.location.href.indexOf("10mm-rope-chain") > -1){
  $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);
    if(radioValue=="Gold")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(100px, 0px, 0px)');
    if(radioValue=="Black")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1150px, 0px, 0px)');
    if(radioValue=="Gunmetal")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2300px, 0px, 0px)');
      if(radioValue=="Stainless Steel")
    jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3300px, 0px, 0px)');
    });
}

  if((window.location.href.indexOf("1mm-rope-chain-new") > -1)||(window.location.href.indexOf("1mm-rope-chain-gold-plated") > -1)){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    //var word = radioValue.split("- ").pop();
    $('.zoomWindowContainer .zoomWindow').css('background-image','url('+$(this).data('image')+')');
    $('.zoomWrapper #product-featured-image').attr('src',$(this).data('image'));
    console.log(radioValue);
      if(window.location.href.indexOf("1mm-rope-chain-gold-plated") > -1){
        if(radioValue=="Gold")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
        if(radioValue=="Black")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1150px, 0px, 0px)');
        if(radioValue=="Gunmetal")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2460px, 0px, 0px)');
        if(radioValue=="Stainless Steel")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-3800px, 0px, 0px)');
        if(radioValue=="Rhodium")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-5110px, 0px, 0px)');
      }else{
      if(radioValue=="Black")
      jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(80px, 0px, 0px)');
      if(radioValue=="Gunmetal")
      jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1300px, 0px, 0px)');
      if(radioValue=="Stainless Steel")
      jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-2620px, 0px, 0px)');    
      }
    
    });
}


  if(window.location.href.indexOf("4mm-figaro-chain-necklace-rhodium") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
  }

  if(window.location.href.indexOf("lifetime-jewelry-1-2mm-cable-link-chain-necklace-for-women-and-men-24k-gold-plated") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
  }

  if(window.location.href.indexOf("1mm-box-chain-necklace-gold-plated-and-rhodium") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-145px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-145px');
    },1200);
  }

  if(window.location.href.indexOf("princess-cut-cubic-zirconia-classic-tennis-bracelet-gold-plated") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
  }

  if(window.location.href.indexOf("extra-large-square-grid-cross") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-1').css('position','relative');
      $('#productSelect-option-1').css('left','132px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-1').css('position','relative');
      $('#productSelect-option-1').css('left','132px');
    },1200);
  }

  if(window.location.href.indexOf("copy-of-extra-large-filigree-crucifix-2") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-1').css('position','relative');
      $('#productSelect-option-1').css('left','132px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-1').css('position','relative');
      $('#productSelect-option-1').css('left','132px');
    },1200);
  }

   if(window.location.href.indexOf("5mm-venetian-chain-ankle-bracelet-24k-gold-plated") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-90px');
    },1200);
  }

  if(window.location.href.indexOf("lifetime-jewelry-ankle-bracelet-for-women-men-teen-girls-2-5mm-diamond-cut-star-flat-link-chain") > -1){
    $('#productSelect-option-0').hide();
    $('#productSelect-option-1').hide();
    setTimeout(function(){
      $('#productSelect-option-0').show();
      $('#productSelect-option-1').show();
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-150px');
    },800);
    setTimeout(function(){
      $('#productSelect-option-0').css('position','relative');
      $('#productSelect-option-0').css('left','-150px');
    },1200);
  }
  
  if(window.location.href.indexOf("lifetime-jewelry-cubic-zirconia-marquise-birthstone-stud-earrings-24k-gold-plated") > -1){
    $(".swatch-section .swatch-element input[name='option-0']").change(function() {
    var radioValue = $(this).val();
    var word = radioValue.split("- ").pop();
      console.log(word);
    if(word){
      if(word=="Amethyst")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(70px, 0px, 0px)');
      if(word=="Peridot")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1345px, 0px, 0px)');
      if(word=="Sapphire")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1190px, 0px, 0px)');
      if(word=="Garnet")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-555px, 0px, 0px)');
      if(word=="Emerald")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-245px, 0px, 0px)');
      if(word=="Alexandrite")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(230px, 0px, 0px)');
      if(word=="Rose Zircon")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-715px, 0px, 0px)');
      if(word=="Diamond")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-80px, 0px, 0px)');
      if(word=="Blue Zircon")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-1030px, 0px, 0px)');
      if(word=="Gold Topaz")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-875px, 0px, 0px)');
      if(word=="Ruby")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-715px, 0px, 0px)');
      if(word=="Aquamarine")
        jQuery("#ProductThumbs .owl-stage").css('transform','translate3d(-400px, 0px, 0px)');
    }
  });
  }
    
});
$(".selectv div.variant2_select_june:first").addClass("active");




$('#small-initial-letter-pendant-necklace [data-option-index="1"] .pendant-only #swatch-1-pendant-only').change(function(){
    if($(this).is(":checked")) {
        $('[data-option-index="1"] .pendant-only').addClass("active");
      $('[data-option-index="1"] .pendant-necklace').removeClass("active");
    } else {
        $('[data-option-index="1"] .pendant-only').removeClass("active");
    }
});

$('#small-initial-letter-pendant-necklace [data-option-index="1"] .pendant-necklace #swatch-1-pendant-necklace').change(function(){
    if($(this).is(":checked")) {
        $('[data-option-index="1"] .pendant-necklace').addClass("active");
      $('[data-option-index="1"] .pendant-only').removeClass("active");
    } else {
        $('[data-option-index="1"] .pendant-necklace').removeClass("active");
    }
});

$('#extra-large-square-grid-cross [data-option-index="1"] #swatch-1-large-cross-necklace-chain').change(function(){
    if($(this).is(":checked")) {
        $('[data-option-index="1"] .large-cross-necklace-chain').addClass("active");
      $('[data-option-index="1"] .square-grid-cross').removeClass("active");
      $('[data-option-index="1"] .fanned-end-narrow-cross').removeClass("active");
    }
});
$('#extra-large-square-grid-cross [data-option-index="1"] #swatch-1-fanned-end-narrow-cross').change(function(){
    if($(this).is(":checked")) {
        $('[data-option-index="1"] .large-cross-necklace-chain').removeClass("active");
      $('[data-option-index="1"] .square-grid-cross').removeClass("active");
      $('[data-option-index="1"] .fanned-end-narrow-cross').addClass("active");
    }
});
$('#extra-large-square-grid-cross [data-option-index="1"] #swatch-1-square-grid-cross').change(function(){
    if($(this).is(":checked")) { 
        $('[data-option-index="1"] .large-cross-necklace-chain').removeClass("active");
      $('[data-option-index="1"] .square-grid-cross').addClass("active");
      $('[data-option-index="1"] .fanned-end-narrow-cross').removeClass("active");
    }
});



$('#extra-large-filigree-crucifix [data-option-index="1"] #swatch-1-fine-crucifix').change(function(){
    if($(this).is(":checked")) {
        $('[data-option-index="1"] .fine-crucifix').addClass("active");
      $('[data-option-index="1"] .swatch-section .radiant-crucifix').removeClass("active");
      $('[data-option-index="1"] .swatch-section .rounded-crucifix').removeClass("active");
    }
});
$('#extra-large-filigree-crucifix [data-option-index="1"] #swatch-1-radiant-crucifix').change(function(){
    if($(this).is(":checked")) {
        $('[data-option-index="1"] .fine-crucifix').removeClass("active");
      $('[data-option-index="1"] .swatch-section .radiant-crucifix').addClass("active");
      $('[data-option-index="1"] .swatch-section .rounded-crucifix').removeClass("active");
      
    }
});
$('#extra-large-filigree-crucifix [data-option-index="1"] #swatch-1-rounded-crucifix').change(function(){
    if($(this).is(":checked")) {
        $('[data-option-index="1"] .fine-crucifix').removeClass("active");
      	$('[data-option-index="1"] .swatch-section .radiant-crucifix').removeClass("active");
       	$('[data-option-index="1"] .swatch-section .rounded-crucifix').addClass("active");
    }
});
jQuery('#copy-of-extra-large-filigree-crucifix #AddToCartForm .without-chain label .crossed-out').after('<img src="https://cdn.shopify.com/s/files/1/1307/9283/files/without-chain.jpg?v=1638528545">');
jQuery('#copy-of-extra-large-filigree-crucifix #AddToCartForm .with-20-chain label .crossed-out').after('<img src="https://cdn.shopify.com/s/files/1/1307/9283/files/with-chain.jpg?v=1638528545">');